import React from 'react'
import { func, oneOf, string } from 'prop-types'
import { capitalize } from 'lodash'

import FBSvg from 'components/atoms/SVGIcons/Facebook'
import TwitterSvg from 'components/atoms/SVGIcons/Twitter'
import IGSvg from 'components/atoms/SVGIcons/Instagram'
import RSSSvg from 'components/atoms/SVGIcons/RSS'
import Youtube from 'components/atoms/SVGIcons/Youtube'

const BaseSocmedIcon = ({ type, url, backgroundColor, onClick }) => {
  const socmedIcons = {
    facebook: <FBSvg fill="#fff"/>,
    twitter: <TwitterSvg fill="#fff"/>,
    instagram: <IGSvg fill="#fff"/>,
    blog: <RSSSvg fill="#fff"/>,
    youtube: <Youtube fill="#fff"/>,
  }
  return (
    <>
      <a
        className="base-socmed-icon"
        href={url}
        target="_blank"
        rel="noopener"
        title={`Official ${capitalize(type)}`}
        onClick={onClick}
      >
        {socmedIcons[type]}
      </a>
      <style jsx>
        {`
          .base-socmed-icon {
            display: inline-block;
            background: ${backgroundColor};
            width: 24px;
            height: 24px;
            padding: 4px;
            border-radius: 4px;
            margin: 4px;
            :global(svg) {
              height: 16px;
              width: 16px;
            }
          }
        `}
      </style>
    </>
  )
}

BaseSocmedIcon.propTypes = {
  type: oneOf(['facebook', 'twitter', 'instagram', 'blog', 'youtube']),
  url: string,
  backgroundColor: string,
  onClick: func,
}

BaseSocmedIcon.defaultProps = {
  backgroundColor: '#8fb0d4',
}

export default BaseSocmedIcon
